import { syncVideoControls } from 'components/mediaControls/helpers';
import MediaControls from 'components/mediaControls/mediaControls.module';
import MediaPreview from 'components/mediaPreview/mediaPreview.module';
import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { FACEBOOK_REGEX, VIDEO_REGEX, VIMEO_REGEX, YOUTUBE_REGEX } from 'consts/consts';
import { MESSAGE_SENDER, MESSAGE_TYPE, VIDEO_TYPES } from 'consts/enum';
import { generate6DigitUUID } from 'helpers/helpers';
import { SendVideoTemplate } from './sendVideo.template';

const { BOT, USER } = MESSAGE_SENDER;

export default class SendVideo {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = {};
		const { video_url, video_caption, enable_download, error_msg } = propData.message?.data;
		this.setter({
			...propData,
			videoUrl: video_url,
			captions: video_caption,
			enableDownload: enable_download,
			id: propData.message_id || generate6DigitUUID(),
			errorMessage: error_msg,
		});
	}

	initWrapper() {
		const { sender = BOT, videoUrl } = this.data;

		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-msg', `engt-msg-${sender}`, 'engt-media-controls-wrapper', 'engt-msg-border-bot');
		const vimeoRegex = new RegExp(VIMEO_REGEX);
		const youtubeRegex = new RegExp(YOUTUBE_REGEX);
		const facebookRegex = new RegExp(FACEBOOK_REGEX);
		const regex = new RegExp(VIDEO_REGEX);
		let platform = '';

		if (vimeoRegex.test(videoUrl)) {
			platform = VIDEO_TYPES.VIMEO;
		} else if (youtubeRegex.test(videoUrl)) {
			platform = VIDEO_TYPES.YOUTUBE;
		} else if (facebookRegex.test(videoUrl)) {
			platform = VIDEO_TYPES.FACEBOOK;
		} else if (regex.test(videoUrl)) {
			platform = VIDEO_TYPES.VIDEO;
		}
		this.setter({
			...this.data,
			platform,
		}),
			(wrapper.innerHTML = SendVideoTemplate(this.data));

		this.html = wrapper;
	}

	initComponents() {
		const { sender = BOT } = this.data;

		const videoElement = this.html.children[0];
		if (this.data.platform === 'video') {
			const videoControls = new MediaControls({
				message_id: this.data.id,
				mediaId: `engtVideo-${this.data.id}`,
				mediaNode: videoElement,
				showControls: sender !== USER,
			});
			this.html.appendChild(videoControls.render());
		}

		this.html = new MessageWrapper({
			...this.data,
			message: MESSAGE_TYPE.VIDEO,
			innerHTML: this.html.outerHTML,
			download: this.data.enableDownload,
			downloadLink: this.data.videoUrl,
			errorMessage: this.data.errorMessage,
		});
	}

	initEventHandlers() {
		const { sender = BOT, id, platform } = this.data;
		if (platform === VIDEO_TYPES.VIDEO) {
			this.html.querySelector(`#engtVideo-${id}`).addEventListener('click', () => {
				const video = this.html.querySelector(`#engtVideo-${id}`);
				if (!video?.paused) {
					video?.pause();
				} else {
					video?.play();
				}
			});

			this.html.querySelector(`#engtVideo-${id}`).addEventListener('dblclick', (e = $event) => {
				new MediaPreview({
					id: this.data.id,
					type: MESSAGE_TYPE.VIDEO,
					children: SendVideoTemplate(this.data),
				}).render();
				const preview = document.getElementById('engtMediaOverlay');
				const video = document.getElementById('engtContent').children[0];
				video.id = 'engtVideoExp';
				const previewControls = new MediaControls({
					mediaId: 'engtVideoExp',
					mediaNode: video,
					isFooter: true,
					bgColor: '#403F42',
					color: '#FFF',
					showControls: sender !== USER,
				});

				preview.appendChild(previewControls.render());
				syncVideoControls(video, e.target, 'control');
			});
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
